module.exports = __webpack_public_path__ + "static/media/icon-progression.b6fcf822.svg";